import React from 'react';
import { ApolloError } from '@apollo/client';
import { copyFor } from 'config';
import { Container, InvisibleHeading } from 'styles';
import { ErrorContent } from 'components/errors/content';
import { Loading } from '../loading';
import { EmptyState } from '../empty-state';
import { NotificationRow } from './notification-row.component';

interface Props {
  notifications?: QueriedNotification[];
  error?: ApolloError;
  loading: boolean;
  isSMB: boolean;
}
const getCopy = copyFor('notifications.currentPastModule');

export const Past = ({ notifications, error, loading, isSMB }: Props) => {
  if (loading) return <Loading />;

  if (error || !notifications)
    return (
      <Container padding="24px" data-testid="error">
        <ErrorContent />
      </Container>
    );
  if (!notifications.length) {
    return <EmptyState tab="past" />;
  }

  return (
    <Container>
      <InvisibleHeading tag="h2">
        {getCopy('accessibleTitles.past')}
      </InvisibleHeading>
      {notifications.map((notification, index) => (
        <NotificationRow
          notification={notification}
          key={notification.id}
          hideTopBorder={index === 0}
          isSMB={isSMB}
        />
      ))}
    </Container>
  );
};
